import React from "react";
import DocumentDrop from "../utils/documentDrop";

const Step3ReviewSubmit = ({ watch, setDocumentFile, err, errType }) => {
  const values = watch();

  return (
    <div className="space-y-6">
      {/* Document Upload */}
      <div>
        <h4 className="text-sm font-semibold text-gray-700 mb-3">Documents</h4>
        <DocumentDrop setDocumentFile={setDocumentFile} />
      </div>

      {/* Review Summary */}
      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
        <h4 className="text-sm font-semibold text-gray-700 mb-3">Review Details</h4>
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 text-sm">
          <div>
            <dt className="text-muted-foreground">Legal Name</dt>
            <dd className="font-medium text-gray-900">{values.companyLegalName || "—"}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Friendly Name</dt>
            <dd className="font-medium text-gray-900">{values.companyFriendlyName || "—"}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Facility Type</dt>
            <dd className="font-medium text-gray-900">{values.facilityType || "—"}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Hourly Billing Rate</dt>
            <dd className="font-medium text-gray-900">
              {values.hourlyPayRate ? `$${values.hourlyPayRate}/hr` : "—"}
            </dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Website</dt>
            <dd className="font-medium text-gray-900 truncate">{values.companyWebsiteUrl || "—"}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Contact Person</dt>
            <dd className="font-medium text-gray-900">{values.contactPersonName || "—"}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Email</dt>
            <dd className="font-medium text-gray-900">{values.contactEmail || "—"}</dd>
          </div>
          <div>
            <dt className="text-muted-foreground">Phone</dt>
            <dd className="font-medium text-gray-900">{values.customerContact || "—"}</dd>
          </div>
        </dl>
      </div>

      {err && errType === "advance" && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
          <span
            className="text-red-600 text-sm"
            dangerouslySetInnerHTML={{ __html: err }}
          />
        </div>
      )}
    </div>
  );
};

export default Step3ReviewSubmit;
